var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3962 15.6871C18.2473 15.9961 21 16.8156 21 17.7779C21 19.0052 16.5229 20.0001 11 20.0001C5.47716 20.0001 1 19.0052 1 17.7779C1 16.8103 3.7827 15.9872 7.66668 15.6821",
    stroke: "#393939",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57471 6.22224C5.57471 3.03866 8.02669 0.5 11.0006 0.5C13.9746 0.5 16.4266 3.03866 16.4266 6.22224C16.4266 9.93058 14.1244 14.5019 11.0006 17.133C7.8769 14.5019 5.57471 9.93058 5.57471 6.22224ZM10.9309 8.50002C12.1593 8.50002 13.1041 7.45123 13.1041 6.22224C13.1041 4.99324 12.1593 3.94445 10.9309 3.94445C9.70257 3.94445 8.75772 4.99324 8.75772 6.22224C8.75772 7.45123 9.70257 8.50002 10.9309 8.50002Z",
    stroke: "#393939",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreas);
export default __webpack_public_path__ + "static/media/areas.b4979f3be97dcf81174bdb50de22184f.svg";
export { ForwardRef as ReactComponent };